import React, { PureComponent } from 'react'
import Overlay from 'views/overlay/overlay'
import { connect } from 'react-redux'
import { localize } from 'helpers/translator'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import privateLibraryActions from 'redux/actions/privateLibraryActions'
import { privateLibrarySelectors } from 'redux/selectors'

class SchoolLibraryOnboardingOverlay extends PureComponent {

	componentDidMount() {
		this.props.actions.overlaySchoolLibraryOnboardingInitialize()
	}

	onButtonConfirm() {
		this.props.actions.overlaySchoolLibraryOnboardingConfirm()
	}

	render() {
		const buttonOne = { text: localize('admin_onboarding_express_gotit_thanks'), action: () => this.onButtonConfirm() }

		return <Overlay
			offerTitle={localize('school_library_onboarding_overlay_title')}
			offerMessage={localize('school_library_onboarding_overlay_body')}
			buttonOne={buttonOne}
			videoIcon={this.props.icon} />
	}
}

function mapStateToProps(state) {
	return privateLibrarySelectors.getSchoolOverlayData(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		overlaySchoolLibraryOnboardingInitialize: privateLibraryActions.overlaySchoolLibraryOnboardingInitialize,
		overlaySchoolLibraryOnboardingConfirm: privateLibraryActions.overlaySchoolLibraryOnboardingConfirm,
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(SchoolLibraryOnboardingOverlay)
